/* eslint-disable */
import { defaultApiInstance } from '@/compositions/api';

export function getDirectionLastSlot(id) {
  return defaultApiInstance.get(`v1/direction/${id}/lastSlot`);
}
